(function ($) {
    $.extend(true, $.jgrid, {
        styleUI: {
            FontAwesome : {
                common : {
                    disabled: "ui-disabled",
                    highlight : "success",
                    hover : "active",
                    cornerall: "",
                    cornertop: "",
                    cornerbottom : "",
                    hidden : "",
                    icon_base : "fas",
                    overlay: "ui-overlay",
                    active : "active",
                    error : "bg-danger",
                    button : "btn btn-primary",
                    content : ""
                },
                base : {
                    entrieBox : "",
                    viewBox : "table-responsive",
                    headerTable : "table table-bordered",
                    headerBox : "",
                    rowTable : "table table-bordered",
                    rowBox : "",
                    footerTable : "table table-bordered",
                    footerBox : "",
                    headerDiv : "",
                    gridtitleBox : "",
                    customtoolbarBox : "",
                    //overlayBox: "ui-overlay",
                    loadingBox : "row",
                    rownumBox :  "active",
                    scrollBox : "",
                    multiBox : "checkbox",
                    pagerBox : "",
                    pagerTable : "table",
                    toppagerBox : "",
                    pgInput : "form-control input-sm",
                    pgSelectBox : "form-control input-sm",
                    pgButtonBox : "",
                    icon_first : "fa-step-backward",
                    icon_prev : "fa-backward",
                    icon_next: "fa-forward",
                    icon_end: "fa-step-forward",
                    icon_asc : "fa-angle-up",
                    icon_desc : "fa-angle-down",
                    icon_caption_open : "fa-circle-arrow-up",
                    icon_caption_close : "fa-circle-arrow-down"
                },
                modal : {
                    modal : "modal-content",
                    header : "modal-header",
                    title : "modal-title",
                    content :"modal-body",
                    resizable : "ui-resizable-handle ui-resizable-se",
                    icon_close : "fa-times",
                    icon_resizable : "fa-import"
                },
                celledit : {
                    inputClass : 'form-control input-sm'
                },
                inlinedit : {
                    inputClass : 'form-control input-sm',
                    icon_edit_nav : "fa-edit",
                    icon_add_nav : "fa-plus",
                    icon_save_nav : "fa-save",
                    icon_cancel_nav : "fa-times"
                },
                formedit : {
                    inputClass : "form-control input-sm",
                    icon_prev : "fa-step-backward",
                    icon_next : "fa-step-forward",
                    icon_save : "fa-save",
                    icon_close : "fa-times",
                    icon_del : "fa-trash",
                    icon_cancel : "fa-times"
                },
                navigator : {
                    icon_edit_nav : "fa-edit",
                    icon_add_nav : "fa-plus",
                    icon_del_nav : "fa-trash",
                    icon_search_nav : "fa-search",
                    icon_refresh_nav : "fa-sync",
                    icon_view_nav : "fa-info-sign",
                    icon_newbutton_nav : "fa-new-window"
                },
                grouping : {
                    icon_plus : 'fa-triangle-right',
                    icon_minus : 'fa-triangle-bottom'
                },
                filter : {
                    table_widget : 'table table-condensed',
                    srSelect : 'form-control input-sm',
                    srInput : 'form-control input-sm',
                    menu_widget : '',
                    icon_search : 'fa-search',
                    icon_reset : 'fa-sync',
                    icon_query :'fa-comment'
                },
                subgrid : {
                    icon_plus : 'fa-triangle-right',
                    icon_minus : 'fa-triangle-bottom',
                    icon_open : 'fa-indent-left'
                },
                treegrid : {
                    icon_plus : 'fa-triangle-right',
                    icon_minus : 'fa-triangle-bottom',
                    icon_leaf : 'fa-unchecked'
                },
                fmatter : {
                    icon_edit : "fa-edit",
                    icon_add : "fa-plus",
                    icon_save : "fa-save",
                    icon_cancel : "fa-times",
                    icon_del : "fa-trash"
                },
                colmenu : {
                    menu_widget : '',
                    input_checkbox : "",
                    filter_select: "form-control input-sm",
                    filter_input : "form-control input-sm",
                    icon_menu : "fa-menu-hamburger",
                    icon_sort_asc : "fa-sort-by-alphabet",
                    icon_sort_desc : "fa-sort-by-alphabet-alt",
                    icon_columns : "fa-list-alt",
                    icon_filter : "fa-filter",
                    icon_group : "fa-align-left",
                    icon_freeze : "fa-object-align-horizontal",
                    icon_move: "fa-move"
                }
            }
        }
    });

    $.extend(true, $.jgrid.defaults, {
        styleUI: 'FontAwesome' // the new option will be used in callbacks
    });
}(jQuery));
